import { IMasterAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { propOr } from 'ramda';

export const getMasterAgentExperience = (masterAgent?: IMasterAgentSchema): string | void =>
  propOr(undefined, 'experience', masterAgent);
